




























































import Vue from 'vue';
import Component from 'vue-class-component';
import BindAttrs from '@/utils/binds-attrs';
import AmetrasAdvancedFilterTemplate from '@/views/AmetrasAdvancedFilterTemplate.vue';
import {Prop} from 'vue-property-decorator';
import {RANGE_SUMMARY_SERVICE_INSTANCE} from '@/services/datatable/range-summary.service';
import {DYNAMIC_FIELD_RESOLVER_INSTANCE, DynamicFieldResolverComponent} from '@/fields/dynamic-field-resolver';
import {HTML_SERVICE_INSTANCE} from '@/services/html.service';

@Component({
  components: {
    AmetrasAdvancedFilterTemplate
  },
  mixins: [BindAttrs]
})
export default class AmetrasDynamicFieldWithAdvancedFilterTemplate extends Vue {

  @Prop({
    type: Array as () => DisguiseDto.SearchValues[],
    required: true
  }) searchValues!: DisguiseDto.SearchValues[];
  @Prop() searchValue!: string;
  @Prop({
    default: false
  }) advancedFilterActive!: boolean;
  @Prop({
    default: false
  }) showAdvancedFilterDialog!: boolean;
  @Prop({
    required: true
  }) fieldConfiguration!: DisguiseDto.DTColumnsDto;
  @Prop({
    required: false
  }) initialTableFocus!: DisguiseDto.IDTFocusable;

  dynamicFieldResolver = DYNAMIC_FIELD_RESOLVER_INSTANCE;

  $refs!: {
    columnfilter: Vue
  };

  mounted() {
    if (this.initialTableFocus && this.initialTableFocus['@type'] === 'DTInitialColumnFocus') {
      const focus = this.initialTableFocus as DisguiseDto.DTInitialColumnFocus;
      if (focus.fieldReferenceDescription
          && focus.fieldReferenceDescription.key
          && this.fieldConfiguration.key === focus.fieldReferenceDescription.key
      ) {

        this.$nextTick(() => {
          const elToFocus = this.$refs.columnfilter;
          if (elToFocus) {
            HTML_SERVICE_INSTANCE.focusFirstNode(elToFocus.$el);
          }
        });
      }
    }
  }

  getSearchValueSummary(searchValues: DisguiseDto.SearchValues[]) {
    return RANGE_SUMMARY_SERVICE_INSTANCE.getSummary(searchValues);
  }
}
